module.exports = __webpack_public_path__ + "img/step6-05.519df0da.jpg";